import React, { Component } from 'react'
import ValidationText from '../../utils/validation/ValidationText';
import InputText from '../../components/inputs/InputText';
import { isValidForm,validate } from '../../utils/validation/CommonValidator';
import DropdownSelect from '../../components/dropdown/Dropdown';
import { ErrorMessage, SuccessMessage } from '../../utils/Messages';
import DatePicker from '../../components/datePicker/DatePicker';
import IndividualMemberService from '../../services/axiosServices/apiServices/IndividualMemberService';
import SingleSelectWithSearch from '../../components/dropdown/SingleSelectWithSearch/SingleSelectWithSearch';
import CorporateMemberServices from '../../services/axiosServices/apiServices/CorporateMemberServices';
import SwalServices from '../../services/swalServices/SwalServices';
import CommonServices from '../../services/axiosServices/apiServices/CommonServices';
import { Navigate } from 'react-router-dom';
import { getAuditContext, getAuthProps } from "../../utils/AuthenticationLibrary";

export default class AddPosting extends Component {


  constructor(props) {
    super(props);
    this.individualMemberServices = new IndividualMemberService();
    this.corporateMemberServices = new CorporateMemberServices()
    this.commonServices = new CommonServices();

    this.swalServices = new SwalServices();

    this.state = {
      individualMemberId: 0,
      memberId: 0,
      companyWithProfileList: [],

          companiesList:[],
          filterCompaniesList:[],
          allMembers:[],
      postingDetails: {
        companyName: "",
            companyNameId:0,
            contactInfoId:0,
        title: "",
        collaborationTypeId: 0,
        description: "",
        deadline: "",
      },

      validationRule: {
        companyName: [
          {
            type: "require",
            message: ErrorMessage.FieldRequired.replace(
              "{0}",
              "Company Name"
            ),
          },
        ],
        title: [
          {
            type: "require",
            message: ErrorMessage.FieldRequired.replace(
              "{0}",
              "Title"
            ),
          },
        ],
        contactInfoId: [
          {
            type: "require",
            message: ErrorMessage.FieldRequired.replace(
              "{0}",
              "Representative"
            ),
          },
        ],
        collaborationTypeId: [
          {
            type: "require",
            message: ErrorMessage.SelectRequired.replace(
              "{0}",
              "Collaboration Type"
            ),
          },
        ],
        description: [
          {
            type: "require",
            message: ErrorMessage.FieldRequired.replace(
              "{0}",
              "Description"
            ),
          },
        ],
        deadline: [
          {
            type: "require",
            message: ErrorMessage.FieldRequired.replace(
              "{0}",
              "Deadline"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }
  isValidateAllFields = () => {
    const returnValidState = isValidForm(
      this.state.postingDetails,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: returnValidState });
    return returnValidState.isValid;
  };
  validateField = (key) => {
    const returnValidState = validate(
      key,
      this.state.postingDetails,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({
      validState: returnValidState,
    });
  };

  handleChange(event) {
    const value = event.target.value;
    const name = event.target.name;
    let detail = this.state.postingDetails;
    detail[name] = value;
    this.setState({ postingDetails: { ...detail } });
  }

  handleChangeForSelector = (e, identity) => {
    if (identity === "CompanyName") {
      let postingDetails = { ...this.state.postingDetails };
      postingDetails.companyName = e.target.value;
      let organisationList =
        postingDetails.companyName && postingDetails.companyName !== ""
          ? this.state.companiesList.filter(
            (x) =>
              x.name
                .toUpperCase()
                .indexOf(postingDetails.companyName.toUpperCase()) > -1
          )
          : this.state.companiesList;
      this.setState({
        postingDetails: postingDetails,
        filterCompaniesList: organisationList,
      });
    }
  }


  uploadDocuments = (event) => {
    const files = Array.from(event.target.files);
    const validFileTypes = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/msword",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "image/jpeg",
      "image/png",
    ];

    const fileUploadPromises = files.map((file) => {
      if (!validFileTypes.includes(file.type)) {
        this.swalServices.Error(
          `Invalid file type: ${file.name}. Allowed formats: jpeg, png, pdf, doc, docx, xls, xlsx.`
        );
        return Promise.reject();
      }

      const request = {
        storagePath: "CollaborationPublishPostDocuments",
        file: file,
        fileName: file.name,
      };

      return this.commonServices
        .uploadPDF(request)
        .then((response) => {
          if (response != null) {
            return response.fileName;
          } else {
            this.swalServices.Error(`Failed to upload file: ${file.name}`);
            return null;
          }
        });
    });

    Promise.all(fileUploadPromises)
      .then((uploadedFiles) => {
        const validUploadedFiles = uploadedFiles.filter((fileName) => fileName);

        if (validUploadedFiles.length > 0) {
          const detail = { ...this.state.postingDetails };
          detail.UploadFile = [
            ...(detail.UploadFile || []),
            ...validUploadedFiles,
          ];
          this.setState({ postingDetails: detail }, () => {
            this.swalServices.Success("Files uploaded successfully.");
          });
        }
      })
      .catch(() => {});
  };



  setFilterParametersForSelector = (id, identity, name) => {
    if (identity === "CompanyName") {
      if (id > 0) {
        this.getIndividualMemberById(id, "CompanyName");
        let collaborationDetails = { ...this.state.postingDetails };
        let companies = [...this.state.companiesList];
        let companyName = companies.find((x) => x.id === id);

        collaborationDetails.companyName = companyName.name;
        collaborationDetails.companyNameId = id;
        this.setState({ postingDetails: collaborationDetails });
      }
    }
  };


  getIndividualMemberById = (id, identity) => {
    this.corporateMemberServices.getRepresentativesById(id).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null && response.responseItem.responseContent.length > 0) {

        if (identity === "CompanyName") {
          let allMembers = response.responseItem.responseContent
          this.setState({ allMembers: allMembers }
          );
        }
      }
    });
  }


  getAllDropDown = () => {
    this.individualMemberServices
      .getAllDropdownForIndividualMember(this.state.contributionDetails)
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let collaborationTypes = response.responseItem.responseContent.filter(
            (drp) => drp.dropdownName === "CollaborationTypes"
          );

          this.setState({ collaborationList: collaborationTypes });
        } else {
          this.swalServices.Error(response.message);
        }
      });
  };

  getRepresentativesById = (id, identity) => {
    this.corporateMemberServices.getRepresentativesById(id).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null && response.responseItem.responseContent.length > 0) {
        if (identity === "OrdinaryMembers") {
          let ordinaryRepresentative = response.responseItem.responseContent
          this.setState({ ordinaryRepresentative: ordinaryRepresentative });
        }
        if (identity === "AllMembers") {
          let allRepresentative = response.responseItem.responseContent
          this.setState({ allRepresentative: allRepresentative }
          );
        }
      } else {
        if (identity === "OrdinaryMembers") {
          this.setState({ ordinaryRepresentative: [] });
        }
        if (identity === "AllMembers") {
          this.setState({ allRepresentative: [] });
        }
      }
    });
  }

  setFilterParameters = (id, drpIdentity) => {
    let detail = { ...this.state.postingDetails };

    if (drpIdentity === "CollaborationType") {
      detail["collaborationTypeId"] = id;
    }

    if (drpIdentity === "Representative") {
      detail["contactInfoId"] = id;
    }

    this.setState({ postingDetails: detail }, () => {
      if (drpIdentity === "CollaborationType") {
        this.validateField("collaborationTypeId");
      }
      if (drpIdentity === "Representative") {
        this.validateField("contactInfoId");
      }
    });
  };


  componentDidMount() {
    this.getAllDropDown();
    this.getAllDropdownsForCompanies();
  }


  getAllDropdownsForCompanies(id) {
    this.corporateMemberServices
      .getAllDropdownsForEndorsers()
      .then((response) => {

        if (response.statusCode === 200 && response.responseItem != null) {
          let allCompanies = response.responseItem.responseContent.filter(
            (drp) =>
              drp.dropdownName === "AllEndorsers"
          );
          allCompanies = allCompanies.filter((drp) => drp.id !== id);
          this.setState({ companiesList: allCompanies, filterCompaniesList: allCompanies });
        }
      });
  }


  addCollaborationPublishPost = () => {

    let req = {};
    const audit = getAuditContext()
    req.collaborationPortalPostTypeId =
      this.state.collaborationPortalPostTypeId ?? 0;
    req.collaborationPortalPostingId  = 0;
    req.title = this.state.postingDetails.title ?? "";
    req.collaboratingPostTypeId =
      this.state.postingDetails.collaborationTypeId ?? 0;
    req.contactInfoId = this.state.postingDetails.contactInfoId;
    req.description = this.state.postingDetails.description ?? "";
    req.deadline = this.state.postingDetails.deadline ?? "";
    req.supportingDocuments =  (Array.isArray(this.state.postingDetails.UploadFile) && this.state.postingDetails.UploadFile.length > 0)
      ? this.state.postingDetails.UploadFile.join(",")
      : "";
    req.memberId = this.state.postingDetails.companyNameId ?? 0;
    req.isAdminPost = true;
    req.createdBy = audit.adminUserId;
    req.createdAppId = audit.appId

    let isValidAll = this.isValidateAllFields();
    if (isValidAll) {
      this.individualMemberServices
        .addEditCollaborationPublishPosts(req)
        .then((response) => {
          if (response.statusCode === 200 && response.responseItem != null) {

            this.swalServices.Success(
              "Collaboration Post has been posted Successfully!"
            );
            this.resetPostingDetails();
            this.back()
          } else {
            this.swalServices.Error(response.message);
          }
        });
    }
  };


  resetPostingDetails() {
    let resetData = this.state.postingDetails;
    resetData.title = "";
    resetData.description = "";
    resetData.collaborationTypeId = 0;
    resetData.deadline = "";
    resetData.UploadFile = [];
    resetData.contactInfoId = 0;
    resetData.companyNameId = 0;
    resetData.companyName= ""
    this.setState({ postingDetails: resetData });
  }


  back = () => {
    this.setState({  route: "/ViewPosting"  });
  }
  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className="main-body-section finance-body-sec">
        {/* Section 1 Start */}
        <div className="bg-white">
          <>
            <div className="add-posting-section">
              <h1 className="top-title">POSTING DETAILS</h1>
              <div className="form-border-card">
                <div className="  w-full ">
                  <div className="grid lg:gap-4 gap-2 grid-cols-12">
                    <div className="lg:col-span-12 md:col-span-12 sm:col-span-12 col-span-12 ">
                      <div className="grid lg:gap-4 gap-2 grid-cols-12 mobile-block">
                        <h2 className="col-span-3 flex items-center form-label">
                          Company Name: <span className="text-[#C00000]">*</span>
                        </h2>
                        <div className="col-span-9 membership-searchbar">

                          <SingleSelectWithSearch
                            drpIdentity={"CompanyName"}
                            optionArray={this.state.filterCompaniesList}
                            handleChange={(e, identity) => this.handleChangeForSelector(e, identity)}
                            searchText={this.state.postingDetails.companyName}
                            setFilterParameters={(id, drpIdentity, name) => this.setFilterParametersForSelector(id, drpIdentity, name)}
                            value={this.state.postingDetails.companyName}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="lg:col-span-12 md:col-span-12 sm:col-span-12 col-span-12 ">
                      <div className="grid lg:gap-4 gap-2 grid-cols-12 mobile-block">
                        <h2 className="col-span-3 flex items-center form-label">
                          Representative: <span className="text-[#C00000]">*</span>
                        </h2>
                        <div className="col-span-9 membership-searchbar">
                          <DropdownSelect
                            drpIdentity={"Representative"}
                            optionArray={this.state.allMembers}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                    value={this.state.postingDetails.contactInfoId ? this.state.postingDetails.contactInfoId : 0}/>                      
                          <ValidationText error={this.state.validState.error.contactInfoId} />
                        </div>

                      </div>
                    </div>

                    <div className="lg:col-span-12 md:col-span-12 sm:col-span-12 col-span-12 ">
                      <div className="grid lg:gap-4 gap-2 grid-cols-12 mobile-block">
                        <h2 className="col-span-3 flex items-center form-label">
                          Title:<span className="text-[#f93549]">*</span>
                        </h2>
                        <div className="col-span-9 membership-searchbar">
                          <InputText
                            placeholder=""
                            type="text"
                            name="title"
                            identity="Employee"
                            autoComplete={"off"}
                            handleChange={(event) => this.handleChange(event)}
                            value={this.state.postingDetails.title}
                        validateField ={()=>this.validateField("title")}
                          />
                          <ValidationText error={this.state.validState.error.title} />

                        </div>
                      </div>
                    </div>
                    <div className="lg:col-span-12 md:col-span-12 sm:col-span-12 col-span-12 ">
                      <div className="grid lg:gap-4 gap-2 grid-cols-12 mobile-block">
                        <h2 className="col-span-3 flex items-center form-label">
                          Collaboration Type<span className="text-[#f93549]">*</span>
                        </h2>
                        <div className="col-span-9 membership-searchbar">
                          <DropdownSelect
                            drpIdentity="CollaborationType"
                            optionArray={this.state.collaborationList}
                            setFilterParameters={(id, drpIdentity) =>
                              this.setFilterParameters(id, drpIdentity)
                            }
                            value={this.state.postingDetails.collaborationTypeId}
                          />
                          <ValidationText error={this.state.validState.error.collaborationTypeId} />

                        </div>
                      </div>
                    </div>

                    <div className="lg:col-span-12 md:col-span-12 sm:col-span-12 col-span-12 ">
                      <div className="grid lg:gap-4 gap-2 grid-cols-12 mobile-block">
                        <h2 className="col-span-3 flex form-label">Description:<span className="text-[#f93549]">*</span></h2>
                        <div className="col-span-9 membership-searchbar">
                          <textarea
                            className="w-full h-32 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-600"
                            type="text"
                            name="description"
                            value={this.state.postingDetails.description}
                            onChange={(event) => this.handleChange(event)}
                            // onBlur={() => props.validateTermination("terminationReason")}
                        onBlur={()=>this.validateField("description")}
                          />
                          <ValidationText error={this.state.validState.error.description} />

                        </div>
                      </div>
                    </div>
                    <div className="lg:col-span-12 md:col-span-12 sm:col-span-12 col-span-12 ">
                      <div className="grid lg:gap-4 gap-2 grid-cols-12 mobile-block">
                        <h2 className="col-span-3 flex items-center form-label">
                          Deadline:<span className="text-[#f93549]">*</span>
                        </h2>
                        <div className="col-span-9 membership-searchbar">
                          <DatePicker
                            placeholder=""
                            name="deadline"
                            // identity="IncorporationDate"
                            value={this.state.postingDetails.deadline}
                            handleChange={(event) => this.handleChange(event)}
                            // onBlur={()=>this.validateField("deadline")}
                        validateField ={()=>this.validateField("deadline")}
                          />
                          <ValidationText error={this.state.validState.error.deadline} />

                        </div>
                      </div>
                    </div>
                    <div className="lg:col-span-12 md:col-span-12 sm:col-span-12 col-span-12 ">
                      <div className="grid lg:gap-4 gap-2 grid-cols-12 mobile-block">
                        <h2
                          className="col-span-3 flex items-center form-label"
                          htmlFor={`upload_File`}
                        >
                          Supported Documents:
                        </h2>
                        <div className="col-span-9 membership-searchbar">
                          <label
                            htmlFor={`upload_File`}
                            className="text-uplod btn-upload lg:text-[16px] text-[16px] text-black"
                          >
                            Upload File
                          </label>
                          <input
                            className="sr-only"
                            id={`upload_File`}
                            type="file"
                            onChange={(event) => this.uploadDocuments(event)}
                          />
                          <div>
                            {Array.isArray(this.state.postingDetails.UploadFile) &&
                              this.state.postingDetails.UploadFile.length > 0 && (
                                <ul>
                                  {this.state.postingDetails.UploadFile.map(
                                    (file, index) => (
                                      <li key={index} className="text-[#757575]">
                                        {file}
                                      </li>
                                    )
                                  )}
                                </ul>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div className="col-span-12 ">
                      <div className="">
                        <div className="flex justify-between gap-4 flex-wrap lg:mt-5 md:mt-5 sm:mt-3 mt-3">

                          <div className="flex gap-4 ml-auto">
                            <button
                              className="btn btn-red text-white font-bold px-8 py-3 rounded w-full sm:w-auto text-base sm:text-lg "
                              onClick={() => this.addCollaborationPublishPost()}
                            >
                              Publish
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>


        </div>

        <div className="flex flex-wrap justify-between space-x-10 mt-12">
          <div>
            <button className="w-32 px-7 py-2 btn-sm btn-gray text-lg text-white" onClick={() => this.back()}>
              Back
            </button>
          </div>
        </div>

      </div>




    )
  }
}
